import React from "react"
import styled from "styled-components"

import Typography from "@material-ui/core/Typography"

import Textarea from "../../textarea"
import IoAnimator from "../../IoAnimator"

import QuoteLeft from "../../../../static/quote-left.svg"
// import QuoteRight from "../../../../static/quote-right.svg"

import * as theme from "../../../theme"

const Quote = ({ name, quote, ...rest }) => {
  return (
    <Container {...rest} animation="fadeInUp">
      <WrapQuote>
        <QuoteLeft />
        <QuoteText content={quote} />
      </WrapQuote>
      <Name variant="h3" color="inherit">
        — {name}
      </Name>
    </Container>
  )
}

export default Quote

const Container = styled(IoAnimator)`
  max-width: 750px;
  /* margin-bottom: 65px; */
  margin: 30px 0;
  color: ${theme.color.primary};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const Name = styled(Typography)`
  padding: 10px 10px 0 0;
`

const QuoteText = styled(Textarea)`
  padding-left: 10px;
  padding-right: 10px;
  font-style: italic;
  p {
    margin: 0;
  }
`
const WrapQuote = styled.div`
  position: relative;
  display: flex;
  svg {
    flex-shrink: 0;
    fill: #84afd2;
  }
`
